import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generateApplePassPNG(user: { name: string; code: string; stamps: number }): Promise<string> {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')!
    
    // Set canvas size for mobile wallet
    canvas.width = 375
    canvas.height = 200
    
    // Background gradient
    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height)
    gradient.addColorStop(0, '#3b82f6')
    gradient.addColorStop(1, '#1d4ed8')
    ctx.fillStyle = gradient
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    
    // Header
    ctx.fillStyle = 'white'
    ctx.font = 'bold 18px Inter, sans-serif'
    ctx.textAlign = 'center'
    ctx.fillText('Loyalty Card', canvas.width / 2, 30)
    
    // User name
    ctx.font = '16px Inter, sans-serif'
    ctx.fillText(user.name, canvas.width / 2, 55)
    
    // Code
    ctx.font = 'bold 24px monospace'
    ctx.fillText(user.code, canvas.width / 2, 85)
    
    // Stamps progress
    ctx.font = '14px Inter, sans-serif'
    ctx.fillText(`${user.stamps}/6 stamps`, canvas.width / 2, 110)
    
    // Stamp circles
    const stampRadius = 12
    const stampSpacing = 40
    const startX = (canvas.width - (5 * stampSpacing)) / 2
    
    for (let i = 0; i < 6; i++) {
      const x = startX + (i * stampSpacing)
      const y = 140
      
      ctx.beginPath()
      ctx.arc(x, y, stampRadius, 0, 2 * Math.PI)
      ctx.fillStyle = i < user.stamps ? '#fbbf24' : 'rgba(255, 255, 255, 0.3)'
      ctx.fill()
      ctx.strokeStyle = 'white'
      ctx.lineWidth = 2
      ctx.stroke()
    }
    
    // Instructions
    ctx.fillStyle = 'rgba(255, 255, 255, 0.9)'
    ctx.font = '12px Inter, sans-serif'
    ctx.fillText('Show this code to staff to earn stamps', canvas.width / 2, 175)
    
    // Convert to data URL
    resolve(canvas.toDataURL('image/png'))
  })
}

export function downloadFile(dataUrl: string, filename: string) {
  const link = document.createElement('a')
  link.href = dataUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}